import React, { useState, useEffect, useRef, useLayoutEffect } from "react";
import log from "../function/log";
import { withStyles } from "@mui/styles";
import { Modal, Button, Input, DatePicker, message } from 'antd';
import AddIcon from "../icon/AddIcon";
import dayjs from 'dayjs';
import utc from "dayjs/plugin/utc";
import locale from "antd/es/date-picker/locale/ja_JP";
import { routerNames } from '../../wordsFile/wordsFile'
import { formatCheck, errorMessage, localstorage } from "../../wordsFile/wordsFile";
import { VW, VH } from "../function/sizeAdapter"
import { IconButton, Box } from "@mui/material";
import { Close } from "@mui/icons-material";
import SupportView from "./SupportView";
import { ApiHelpFile, ApiStorageHelpFile } from "../../network/api";
import { Document, Page, pdfjs } from "react-pdf";
import "react-pdf/dist/Page/AnnotationLayer.css";
import "react-pdf/dist/Page/TextLayer.css";
// Import the worker as recommended by react-pdf documentation
pdfjs.GlobalWorkerOptions.workerSrc = `//cdnjs.cloudflare.com/ajax/libs/pdf.js/${pdfjs.version}/pdf.worker.js`;

dayjs.extend(utc)


const openHelpRecordInput = () => {
    alert('test')

}
const styles = (theme) => ({
    noneButton: {
        '& .ant-modal-footer': {
            display: 'none'
        }
    },
    buttonGroup: {
        width: '100%',
        display: 'flex',
        alignItems: 'flex-end',
        justifyContent: 'center',
        marginTop: VH(40),
        '& > Button': {
            borderRadius: "4px",
            width: VW(400),
            height: VH(50),
            fontSize: VW(16),
            fontWeight: 'bold',
            color: theme.palette.primary.main,
            border: `1px solid ${theme.palette.primary.main}`,
        },
        '& > Button:nth-child(2)': {
            color: '#FFF',
            backgroundColor: theme.palette.primary.main,
            marginLeft: VW(16)
        }
    },
    buttonGroup2: {
        width: '100%',
        display: 'flex',
        justifyContent: 'center',
        marginTop: VH(40),
        '& > Button': {
            width: VW(533),
            height: VH(56),
            borderRadius: VW(4),
            fontSize: VW(16),
            fontWeight: 700,
            backgroundColor: "#ffffff",
            color: "#2195D3",
            border: `1px solid #2195D3`,
        }
    },
    tableTitle: {
        width: '100%',
        display: 'flex',
        alignItems: 'center',
        fontSize: VW(20),
        marginBottom: 10,
        marginBottom: VH(30)
    },
    subtitleSign: {
        width: 5,
        height: 30,
        marginRight: 0,
        background: '#0A679A'
    },
    subtitle: {
        display: 'flex',
        height: 45,
        alignItems: 'flex-end',
        marginBottom: 5,
        fontWeight: 700
    }
});



function HelpDialog(props) {
    const {
        classes,
        open,
        onClose,
        title
    } = props

    const [url, setUrl] = useState(null)
    const [error, setError] = useState(false)
    const [page, setPage] = useState(0)
    const [modalWidth, setModalWidth] = useState(null);
    const modalRef = useRef(null);




    useEffect(() => {
        if (open) {
            if (title === "【預かり作業状況】") {
                ApiStorageHelpFile().then(res => {
                    let resData = res.data
                    if (res.status === 200) {
                        setUrl(resData)
                    } else {
                        setError(true)
                    }
                }).catch(err => {
                    setError(true)

                })
            } else {
                ApiHelpFile().then(res => {
                    let resData = res.data
                    if (res.status === 200) {
                        setUrl(resData)
                    } else {
                        setError(true)

                    }
                }).catch(err => {
                    setError(true)

                })
            }

        } else {
            setUrl(null)
            setError(false)
        }
    }, [open])

    useEffect(() => {
        if (modalRef.current) {
            const resizeObserver = new ResizeObserver(() => {
                if (modalWidth !== modalRef.current.offsetWidth) { 
                    setModalWidth(modalRef.current.offsetWidth);
                }
             
            });
            resizeObserver.observe(modalRef.current);

            return () => {
                resizeObserver.disconnect();
            };
        }
    }, [open]);


    return (
        <Modal
            open={open}
            onCancel={onClose}
            className={classes.noneButton}
            centered
            // width={VW(640)}
            closable={false}
            width="90vw"
            // width={modalWidth}
            // style={{ maxWidth: '100vw', maxHeight: "80vh", }}
            style={{ maxWidth: '100vw' }}
            
            // bodyStyle={{  }}
            bodyStyle={{
                padding: '0', margin: 0,
                // スクロール領域をbodyに設定し、iOSの慣性スクロールを有効化
                maxHeight: '80vh',
                overflowY: 'auto',
                WebkitOverflowScrolling: 'touch',
                // display: 'flex', justifyContent: 'center', alignItems: 'center'

            }}
        >
            <Box
                ref={modalRef}
                style={{ paddingBottom: 20}}
            >
                <div className={classes.tableTitle}>
                    <div style={{ fontWeight: 'bold', marginLeft: VW(8) }}>{title}</div>


                    <IconButton
                        onClick={onClose}
                        sx={{
                            position: "absolute",
                            right: VW(24),
                        }}
                    >
                        <Close style={{ color: "#333333", width: VW(23.33), height: VW(23.33) }} />
                    </IconButton>
                </div>
                {error ? <div>
                    ヘルプ文言ファイルが見つかりませんでした。管理者にお問い合わせください。
                </div> :
                    <div
                    // ref={modalRef}
                    >
                        <Document
                            file={url}
                            loading={""}
                            noData={""}
                            onLoadSuccess={(pageInfo) => {
                                setPage(pageInfo.numPages);
                            }}
                        // options={{ workerSrc: "/pdf.worker.min.js" }}
                        >
                            <Page
                                width={modalWidth}
                                // scale={1.5}
                                pageNumber={page}
                            // scale={title === "【預かり作業状況】" ? 1 : 2.3}
                            />
                        </Document>
                    </div>
                }

            </Box>
        </Modal >
    )
}

HelpDialog.defaultProps = {

}

export default withStyles(styles, { withTheme: true })(HelpDialog);